import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { RebalanceComponent } from './components/rebalance/rebalance.component';
import { AuthGuard } from 'common';
import { FixedTokenComponent } from 'common-rebalancing';

const routes: Routes = [
  // [20250108] Currently we use rebalance as starting point
  // {
  //   path: '',
  //   loadChildren: () =>
  //     import('./components/home/home.module').then(module => module.HomeModule),
  //   data: {
  //     title: '31Third App',
  //     description: 'Blockchain-native prime brokerage.',
  //     ogUrlPath: '',
  //   },
  // },
  {
    path: 'rebalance',
    component: RebalanceComponent,
    data: {
      title: '31Third Rebalancing',
      description: 'Rebalance your portfolio.',
      ogUrlPath: 'rebalance',
      ogImagePath: 'https://assets.31third.com/images/og/rebalance.png',
    },
  },
  {
    path: 'rebalance/history',
    loadChildren: () =>
      import('./components/history/history.module').then(
        module => module.HistoryModule,
      ),
    data: {
      title: '31Third Trading - History',
      description: 'See all your historical trades done on 31Third Trading',
      ogUrlPath: 'history',
    },
  },
  {
    path: 'rebalance/settings',
    loadChildren: () =>
      import('./components/settings/settings.module').then(
        module => module.SettingsModule,
      ),
    data: {
      title: '31Third Trading - Settings',
      description: 'Settings for 31Third basket trades',
      ogUrlPath: 'settings',
    },
  },
  {
    path: 'rebalance/liquidity',
    loadChildren: () =>
      import('./components/liquidity-bot/liquidity-bot.module').then(
        module => module.LiquidityBotModule,
      ),
    data: {
      title: '31Third Trading - Liquidity',
      description: 'Request liquidity',
      ogUrlPath: 'liquidity',
    },
  },
  {
    path: 'rebalance/enzyme/:vault',
    loadComponent: () =>
      import('./components/rebalance/enzyme-vault').then(
        enzymeVault => enzymeVault.RebalanceEnzymeVaultComponent,
      ),
    data: {
      title: '31Third Trading',
      description: 'Rebalance your Enzyme vault.',
      ogUrlPath: '',
    },
  },
  {
    path: 'rebalance/index/:index',
    loadComponent: () =>
      import('common-rebalancing').then(lib => lib.RebalancingIndexComponent),
    data: {
      title: '31Third Trading',
      description:
        'Directly invest into index based portfolios without third party risk involved.',
      ogUrlPath: '',
    },
  },
  {
    path: 'rebalance/wallet/:walletAddress',
    loadChildren: () =>
      import('./components/follow-wallet/follow-wallet.module').then(
        module => module.FollowWalletModule,
      ),
    data: {
      title: '31Third Trading',
    },
  },
  {
    path: 'rebalance/allin/:fixedToken',
    component: FixedTokenComponent,
    data: {
      title: '31Third Trading',
    },
  },
  {
    path: 'enzyme-leverage',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./components/enzyme-leverage-ep/enzyme-leverage-ep.module').then(
        module => module.EnzymeLeverageEpModule,
      ),
    data: {
      admin: true,
      title: '31Third Trading - Enzyme leverage EP',
      description: 'Add leverage EP to your Enzyme vault',
      ogUrlPath: 'enzyme-leverage',
    },
  },
  {
    path: 'portfolio',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./components/portfolio/portfolio.module').then(
        module => module.PortfolioModule,
      ),
    data: {
      title: '31Third Portfolio',
      description: 'Manage portfolios with 31Third App',
      ogUrlPath: 'portfolio',
    },
  },
  {
    path: 'automation/:id',
    // canActivate: [AuthGuard],
    loadComponent: () =>
      import('./components/automation').then(
        automation => automation.AutomationComponent,
      ),
    data: {
      admin: true,
      title: '31Third - Automation',
      description: 'Automated your portfolio',
      ogUrlPath: 'automation',
      ogImagePath: 'https://assets.31third.com/images/og/automation.png',
    },
  },
  {
    path: 'automation',
    // canActivate: [AuthGuard],
    loadComponent: () =>
      import('./components/automation').then(
        automation => automation.AutomationComponent,
      ),
    data: {
      admin: true,
      title: '31Third - Automation',
      description: 'Automated your portfolio',
      ogUrlPath: 'automation',
      ogImagePath: 'https://assets.31third.com/images/og/automation.png',
    },
  },
  {
    path: 'safe-policy-deployer',
    loadComponent: () =>
      import('./components/safe-policy/safe-policy.component').then(
        module => module.SafePolicyComponent,
      ),
    data: {
      admin: true,
      title: '31Third - Safe Policy',
      description: 'Deploy configurable policies to your Safe',
      ogUrlPath: 'safe-policy-deployer',
      ogImagePath:
        'https://assets.31third.com/images/og/safe-policy-deployer.png',
    },
  },
  {
    path: 'safe-policy',
    redirectTo: 'safe-policy-deployer',
    pathMatch: 'full',
  },
  {
    path: 'testnet',
    loadChildren: () =>
      import('./components/add-testnet/add-testnet.module').then(
        module => module.AddTestnetModule,
      ),
    data: {
      title: '31Third Trading - Add Testnet',
      description:
        'Add 31Third Testnet to try our Multi Asset Trading without any risk.',
      ogUrlPath: 'testnet',
    },
  },
  {
    path: 'requesttoken',
    loadChildren: () =>
      import('./components/request-token/request-token.module').then(
        module => module.RequestTokenModule,
      ),
    data: {
      title: '31Third Trading - Request Token',
      description: 'Request support of missing token for trading',
      ogUrlPath: 'requesttoken',
    },
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'administration',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./components/administration/administration.module').then(
        module => module.AdministrationModule,
      ),
    data: {
      admin: true,
      title: '31Third Trading - Administration',
      description: 'Manage 31Third system',
      ogUrlPath: 'administration',
    },
  },
  {
    path: 'admin',
    redirectTo: 'administration',
  },
  {
    path: '**',
    redirectTo: 'rebalance',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 5],
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
